import {
  PermissionTiers,
  type PermissionTierEnum,
} from '../entities/enums/PermissionTierEnum'
import { type Permission } from '../entities/Permission'

/**
 * Computes the role tier based on selected permissions.
 * A role is Pro if it has at least one permission with tier = "Pro", otherwise Basic.
 * This mirrors the backend logic where tier is computed from PermissionMeta.tier.
 */
export const computeTierFromPermissions = (
  permissions: Permission[]
): PermissionTierEnum => {
  const hasProPermission = permissions.some(
    (p) => p.tier === PermissionTiers.PRO
  )
  return hasProPermission ? PermissionTiers.PRO : PermissionTiers.BASIC
}
